const r = (o) => {
  let t;
  try {
    t = new URL(o);
  } catch {
    return !1;
  }
  return t.protocol === "http:" || t.protocol === "https:";
}, i = (o, t = 200) => {
  window != null && window.location && r(o) && setTimeout(() => window.location.assign(o), t);
};
export {
  i as maybeNavigateToUrlWithDelay
};
//# sourceMappingURL=helpers.mjs.map
